import { Component, Input } from '@angular/core';
import { DynamicPropertyDto } from '../../../service/dto';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
	selector: 'app-dynamic-entity-field-selector',
	standalone: false,
	templateUrl: './dynamic-entity-field-selector.component.html',
	styleUrl: './dynamic-entity-field-selector.component.scss'
})
export class DynamicEntityFieldSelectorComponent {
	@Input()
	availableFields!: DynamicPropertyDto[];
	selectedField?: DynamicPropertyDto;

	constructor(private modalRef: NzModalRef) { }

	submit() {
		this.modalRef.destroy(this.selectedField);
	}

	cancel() {
		this.modalRef.destroy(null);
	}
}
